import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { useEffect, useState } from 'react';
import "./DateRangeComponent.css";

const DateRangeComponent = ({ startDate, endDate, apply, setdatename, maxDate, minDate}) => {
    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    useEffect(() => {
        setSelectionRange({
            startDate: startDate ? startDate : new Date(),
            endDate: endDate ? endDate : new Date(),
            key: 'selection',
        });
    }, [])

    const handleSelect = (ranges) => {
        setSelectionRange(ranges.selection);
    };

    const handleApply = () => {
        apply({
            startDate: selectionRange?.startDate,
            endDate: selectionRange?.endDate
        });
        setdatename("");
    }
    return (
        <div
            style={{
                width: "fit-content",
                boxShadow: "0px 4px 10px 4px rgba(130, 130, 130, 0.10)",
                borderRadius: 8,
                userSelect:"none",
                backgroundColor:"white",
                paddingBottom:"01px"
            }}
        >
            <DateRange
                ranges={[selectionRange]}
                onChange={handleSelect}
                maxDate={maxDate ? new Date(maxDate) : new Date()}
                minDate={minDate ? new Date(minDate) : new Date()}
            />
            <div style={{ borderTop: "1px solid #EAEAED", paddingBottom: 24, marginLeft: 16, marginRight: 16, paddingTop: 16, paddingBottom: 32 }} >
                <div style={{ display: "flex", justifyContent: "space-between" }} >
                    <div>
                        <div style={{ color: "#97979A", fontSize: 12, letterSpacing: 1.6 }} >SELECTED DAYS</div>
                        <div style={{ fontSize: 14, fontWeight: 700, marginTop: 8 }} >
                            {String(selectionRange?.startDate?.getDate()).padStart(
                  2,
                  "0"
                ) + "/" + String(selectionRange?.startDate?.getMonth() + 1).padStart(
                    2,
                    "0"
                  ) + "/" + selectionRange?.startDate?.getFullYear()} - { String(selectionRange?.endDate?.getDate()).padStart(
                    2,
                    "0"
                  ) + "/" + String(selectionRange?.endDate?.getMonth() + 1).padStart(
                    2,
                    "0"
                  ) + "/" + selectionRange?.endDate?.getFullYear()}
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }} >
                        <div style={{ color: "#97979A", fontSize: 12, letterSpacing: 1.6 }} >DAYS</div>
                        <div style={{ fontSize: 14, fontWeight: 700, marginTop: 8 }} > 20 DAYS</div>
                    </div>
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginLeft: 16, marginRight: 16, marginBottom: 24 }} >
                <div style={{
                    display: "flex", alignItems: "center", justifyContent: "center", height: 32, width: 136, borderRadius: 4,
                    border: "1px solid #EAEAED",
                    fontSize: 12, fontStyle: "normal", fontWeight: 700, lineHeight: "18px",
                    cursor: "pointer"
                }} onClick={()=>setdatename("")
                }>Cancel
                </div>
                <div style={{
                    display: "flex", alignItems: "center", justifyContent: "center", height: 32, width: 136, borderRadius: 4,
                    border: "1px solid #1565C0",
                    backgroundColor: "#1565C0",
                    color: "white",
                    cursor: "pointer",
                    fontSize: 12, fontStyle: "normal", fontWeight: 700, lineHeight: "18px",

                }}
                    onClick={handleApply}
                >
                    Apply
                </div>
            </div>
        </div>
    )
}

export default DateRangeComponent;